// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"706":"8d6fda01","775":"226a7c53"}[chunkId] + ".chunk.js";
};